export class Claim {
	userId: string;
	type: string;
	value: string;
}